import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "label" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "switch" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("label", {
    class: ["switch-container", _ctx.classList]
  }, [
    _createVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _createVNode("input", {
      class: "input",
      type: "checkbox",
      checked: _ctx.checked,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeEvent($event.target.checked)))
    }, null, 40, ["checked"]),
    _hoisted_2
  ], 2))
}